import { converge } from 'ramda';

import { FreeTrialDuration } from './freetrialDuration';
import { StoreBenefits } from './storeBenefits';

const Products = converge(
  (storeBenefits, freeTrialDuration) => ({
    storeBenefits,
    freeTrialDuration,
  }),
  [StoreBenefits, FreeTrialDuration],
);

export { Products };
